import React, { useContext } from 'react';
import { openStoreLocatorSidebar } from '../../StoreLocator/storeLocatorSidebarState';
import { ProductContext } from '../../../ProductContext';
import { sddState } from '../../Sdd/sddState';
import { useCheckIfUserIsInUS } from 'src/scripts/templates/_shared/react-hooks';
import { SddMessaging } from '../../Sdd/SddMessaging';
import styles from './style.module.scss';
import { isHandbagPDPTemplate } from '../../../utils';
import { EXCHANGE_ONLY_TAG, FINAL_SALE_TAG } from 'src/scripts/utils/constants';
import { isTagPresent } from 'src/scripts/utils/helpers';
import { ReturnsHandbagCopy } from '../../ReturnsSuggestion';

const ShipToMeTabPanel = ({ productTags }: { productTags: string[] }) => {
  const isDomestic = useCheckIfUserIsInUS();

  const shouldDisplaySddMessaging = isDomestic && sddState.enabled;
  return (
    <div className={styles.shipToMeTabPanel}>
      {isHandbagPDPTemplate() ? <ReturnsHandbagCopy /> : <FreeShippingAndReturns productTags={productTags} />}
      {shouldDisplaySddMessaging && <SddMessaging shouldShowOmniPdpExperience={true} />}
    </div>
  );
};

const FreeShippingAndReturns = ({ productTags }: { productTags: string[] }) => {
  const { sidebarPdpData } = useContext(ProductContext);
  const hasFinalSaleTag = isTagPresent(productTags, FINAL_SALE_TAG);
  const hasExchangeOnlyTag = isTagPresent(productTags, EXCHANGE_ONLY_TAG);

  const handleReturnsClick = () => {
    openStoreLocatorSidebar({ feature: 'sdd', pdpProps: sidebarPdpData || undefined, page: 'pdp', openTab: 'returns' });
  };

  return (
    <div className={styles.freeShippingAndReturns}>
      <div>
        <span className="alo-truck-icon"></span>
      </div>
      <div className={styles.messagesContainer}>
        <span className="body-small">
          Free Shipping{hasFinalSaleTag || hasExchangeOnlyTag ? `` : ` & Free Returns`}{' '}
          <span role="button" className="body-small semibold underline" onClick={handleReturnsClick}>
            Details
          </span>
        </span>
        {hasFinalSaleTag || hasExchangeOnlyTag ? (
          <span className="body-small red">
            This item is {hasFinalSaleTag ? `final sale` : `exchange only`}.{' '}
            <a className="body-text-link-small red" href="/pages/returns-exchanges" target="_blank" rel="noopener">
              More info
            </a>
          </span>
        ) : null}
      </div>
    </div>
  );
};

export default ShipToMeTabPanel;
